import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';
import { useNavigate } from "react-router-dom";
import "./subjectlayout.css"
import Swal from 'sweetalert2';

export const UserSubjectLayout = () => {
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation()
    const [subjects, setSubjects] = useState([]);
    const [activeCourse, setactiveCourse] = useState([]);
    const navigate = useNavigate();



    const handleClick = event => {
        if (event.target.id <= activeCourse.sortId) {
            navigate("/user/course/question/" + event.target.id + "/1");
        }
        else {
            Swal.fire({
                title: "Hata",
                text: "Önce aktif konunu bitirmelisin.",
                icon: "error",
            });
        }
        //navigate("/user/course/question/" + event.target.id + "/1");
    };
    const handleReport = event => {
        alert("rapor sayfası düzenlenmektedir.")
    };


    useEffect(() => {

        const fetchdata = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/user/Content/GetSubject";

                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            const subjectsData = res.data['data']['subjects'] || [];
                            setSubjects(subjectsData);
                            const active = res.data['data']['subject'];
                            if (!active) {
                                setactiveCourse(subjectsData[0] || {});
                            } else {
                                setactiveCourse(active);
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchdata();
        const handleContextMenu = (e) => e.preventDefault();
        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);
    const sortedCourses = [...subjects].sort((a, b) => {
        if (a.id === activeCourse.id) return -1;
        if (b.id === activeCourse.id) return 1;
        return 0;
    });
    return (
        <div >
            <div className="row">
                <h4>{msg}</h4>
                {!loading && (
                    <div>
                        {sortedCourses && sortedCourses.map((dt) => {
                            if (dt.id === activeCourse.id) {

                                return (
                                    <div style={{ marginTop: "1%", backgroundColor: "Cornsilk" }} class="card card-primary card-outline" key={dt.id}>
                                        <div class="row">
                                            <div class="col-md-9 d-flex flex-column justify-content-center text-center">
                                                <div class="card-body" >
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title">Aktif Konu : ' + dt.subjectName + '</h5>' }}></div>
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title"> ' + dt.subjectDesc + '</h5>' }}></div>

                                                    <hr />

                                                    <a onClick={handleClick} id={dt.sortId} class="btn btn-primary modern-btn">
                                                        Soruları Gör
                                                    </a>

                                                    <a onClick={handleReport} id={dt.id} class="btn btn-info modern-btn ms-2">
                                                        Raporu Gör
                                                    </a>

                                                </div>
                                            </div>
                                            <div class="col-md-3 d-flex justify-content-center align-items-center" >
                                                <img style={{ maxHeight: "100px" }} src={dt.featuredImage} class="img-fluid rounded-start"
                                                    alt="..." />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            else {
                                return (
                                    <div style={{ marginTop: "1%", backgroundColor: "Gainsboro" }} class="card card-primary card-outline" key={dt.id}>
                                        <div class="row">
                                            <div class="col-md-9 d-flex flex-column justify-content-center text-center">
                                                <div class="card-body">
                                                    <div dangerouslySetInnerHTML={{ __html: '<p class="card-title"><b>' + dt.subjectName + '</b></p>' }}></div>
                                                    <div dangerouslySetInnerHTML={{ __html: '<h5 class="card-title"> ' + dt.subjectDesc + '</h5>' }}></div>

                                                    <hr />

                                                    <a onClick={handleClick} id={dt.sortId} class="btn btn-primary modern-btn">
                                                        Soruları Gör
                                                    </a>

                                                    <a onClick={handleReport} id={dt.id} class="btn btn-info modern-btn ms-2">
                                                        Raporu Gör
                                                    </a>

                                                </div>
                                            </div>
                                            <div class="col-md-3 d-flex justify-content-center align-items-center" >
                                                <img style={{ maxHeight: "100px" }} src={dt.featuredImage} class="img-fluid rounded-start"
                                                    alt="..." />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </div>
                )}


            </div>
        </div>

    );
}
export default UserSubjectLayout;



